module.exports = __webpack_public_path__ + "img/DNADamage-PDAC_GSE205354.d3073dec.png";